import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { WinCardNinthVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant9',
  styleUrl: './variant9.component.scss',
  templateUrl: './variant9.component.html',
  imports: [NgOptimizedImage, SafePipe, RewardPipe, VariableReplacementPipe],
})
export class Variant9Component extends BaseComponent {
  amount = input<number>(0);
  config = input.required<WinCardNinthVariantConfig>();
}
